import { TimeOffType } from '@app/models/time-off-v3/time-off-type.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { getTime } from '@app/modules/time-off-v3/functions/time-unit-converter';
import { TimeOffTransaction } from '@models/time-off-v3/time-off-transaction.model';

export class ChangeColumn extends Column {
    title = 'time-off-v3.change';
    property = 'amount';
    type: CellDisplay = CellDisplay.string;

    constructor(private timeOffTypes: TimeOffType[]) {
        super();
    }

    getRowStyling(transaction: TimeOffTransaction): { [key: string]: string } {
        if (transaction.amount > 0) {
            return { color: `var(--success-500)` };
        } else if (transaction.amount < 0) {
            return { color: `var(--error-800)` };
        }
        // Otherwise pick the default color of the table
    }

    getDisplayPropertyValue(transaction: TimeOffTransaction): string {
        const prefix = transaction.amount > 0 ? '+' : '';

        const timeOffType: TimeOffType = this.timeOffTypes.find(
            (timeOffType) => timeOffType.id === transaction.timeOffTypeId
        );

        const amount = getTime(Number(transaction.amount), timeOffType, { hoursPerDay: transaction.hoursPerDay });

        return `${prefix}${amount.toFixed(2)}`;
    }
}
